import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderBy } from './orderbypipe';
import { GroupByPipe } from './group-by.pipe';
import { SafePipe } from './safe-pipe.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [OrderBy, GroupByPipe, SafePipe],
    exports: [OrderBy, GroupByPipe, SafePipe]
})

export class SharedPipesModule { }




// WEBPACK FOOTER //
// ./src/app/shared/pipes/shared-pipes.module.ts